//@ts-nocheck
import { Box } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { IRootStore } from "../stores";
import { CredentialsForm } from "../_new_/components/formset-without-modal/Credentials";
import { useSaveHook } from "./utils";
type Props = {
  store: IRootStore;
  saveTutorInfo: (data: any) => Promise<any>;
};

const EducationHistoryPage = ({ store, saveTutorInfo }: Props) => {
  const { loading, onSubmitSection } = useSaveHook(saveTutorInfo);

  async function onSubmit(_formValues: any, _redirect = true) {
    return onSubmitSection({
      educationWorkHistory: store.educationWorkHistory.formValues,
    });
  }
  return (
    <Box
      as="section"
      className="forms-section"
      maxW={["100%", "100%", "640px"]}
      px={[5, 8, 0]}
      py={[10, 12]}
      mx="auto"
    >
      <CredentialsForm
        loading={loading}
        inContainer={true}
        store={store.educationWorkHistory}
        educationData={store.educationWorkHistory.data}
        countries={store.locationInfo.countries.map((country) => ({
          label: country.name,
          value: country.name,
        }))}
        onSubmit={onSubmit}
      />
    </Box>
  );
};

export default observer(EducationHistoryPage);
